
export default function MasterSection() {
  return (
    <section className="bg-[#2A2A2A] py-16 sm:py-24 md:py-28 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-5 gap-8 sm:gap-12 items-center">
          <div className="md:col-span-2 flex justify-center">
            <div className="relative">
              <div className="w-64 h-64 sm:w-72 sm:h-72 md:w-80 md:h-80 rounded-full border-4 sm:border-6 border-[#EA9D00] overflow-hidden shadow-2xl">
                <img
                  src="https://cursos.llcosmeticos.com.br/wp-content/uploads/2025/09/liliane-oliveira-.png"
                  alt="Master Liliane Oliveira - Especialista em Mix Express"
                  title="Master Liliane Oliveira - 20 anos de experiência"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="md:col-span-3 md:pr-16">
            <h3 className="text-lg sm:text-xl md:text-2xl text-white font-normal mb-2 sm:mb-3">
              Quem fará a Live:
            </h3>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#EA9D00] mb-6 sm:mb-8 leading-tight">
              Master Liliane Oliveira
            </h2>
            <div className="space-y-4 sm:space-y-6 text-white text-base sm:text-lg leading-relaxed">
              <p>
                Cabeleireira e empreendedora com mais de{' '}
                <strong className="text-[#EA9D00]">20 anos de experiência</strong> em salões de alto padrão.
              </p>
              <p>
                Pioneira da técnica exclusiva da{' '}
                <strong className="text-[#EA9D00]">Cristalização Lipídica</strong>, já capacitou{' '}
                <strong className="text-[#EA9D00]">centenas de profissionais</strong> a multiplicar seus lucros com o método e encanta dezenas de clientes semanalmente com um serviço rápido, seguro e de alto valor agregado.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
